import { omit } from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DynamicImageProps } from './types';
import { generateThumborImgUrl } from './utils';

export const DynamicImage: React.FC<DynamicImageProps> = (props) => {
  const { height, width, sourceHeight, sourceWidth, src } = props;
  if (!src) {
    console.error('Dynamic image is missing path!');
    return null;
  }

  if (!sourceHeight && !sourceWidth) {
    console.error('Dynamic image is missing source size!');
    return null;
  }

  const imageHeight = height ?? sourceHeight;
  const imageHeightString = typeof imageHeight === 'number' ? `${imageHeight}px` : imageHeight;
  const imageWidth = width ?? sourceWidth;
  const imageWidthString = typeof imageWidth === 'number' ? `${imageWidth}px` : imageWidth;

  const imageSrc = generateThumborImgUrl({ src, width: sourceWidth, height: sourceHeight });

  // these are needed to force a box size that can be collided with in chrome
  const minSizing = 'min-w-[1px] min-h-[1px]';

  return (
    <LazyLoadImage
      className={`object-cover object-center ${minSizing} ${props.className}`}
      {...omit(props, ['className', 'sourceHeight', 'sourceWidth', 'objectPosition'])}
      width={imageWidthString}
      height={imageHeightString}
      src={imageSrc}
      alt={props.alt}
      data-resized
      threshold={300}
    />
  );
};
